export function simpleSlugify(text: string) {
  return text.toLowerCase().trim().replace(/ +/g, '_').replace(/_+/g, '-');
}
